export default "__VITE_ASSET__BABI7iUG__"